import { get } from '../../http';

const state = {};
const getters = {};
const mutations = {};
const actions = {
  async getAdUsers () {
    const res = await get(`/admin/advertiser/adminselect`);
    return res.data;
  },
  async getOrderById ({ state, commit }, id) {
    const res = await get(`/admin/order/${id}`);
    return res.data;
  },
  async getOrderListByAdUserId ({ state, commit, rootState }, id) {
    const global = rootState.login.adType !== 'radio' ? 'global-order' : 'order'
    const params = {}

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/admin/${global}/get-orders-for-ad/${id}`, params);
    return res.data;
  },
  async getOrderData ({ state, commit, rootState }, id) {
    const global = rootState.login.adType !== 'radio' ? 'global-order' : 'order'
    const params = {}

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/admin/${global}/get-order-info/${id}`);
    return res.data;
  },
  async getNgaOrient({ state, commit }, { data }) {
    const response = await get('/interface/nga/sections', { ...data })
    return response
  },
  async getFirstAppStoreOptions({ state, commit }, { data } = {}) {
    const response = await get('/interface/item/first_app_store', { ...data })
    return response
  },
  async getVerifyList ({ state, rootState }, params) {
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/admin/${global}ads/verify-list`, params)
    return res.data
  },
  async getAdList ({ state, rootState, commit }, params) {
    rootState.global.advertise.page.loading = true;
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/admin/${global}ads`, params);
    const {
      data: { data },
      header
    } = res.data;
    rootState.global.advertise.page.setPageData(
      {
        header,
        data: data.data.map(item => ({ ...item, editing: false })),
        total: data.total
      },
      false
    );
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
